import React from 'react';

const photo = `${process.env.PUBLIC_URL}/photos/developer-roman.jpg`;

const Volunteers = () => {
    return (
        <section id="volunteers" className="section">
            <div className="container">
                <div className="section-head reveal">
                    <h2 className="section-title">Наши <span className="accent">волонтёры</span></h2>
                    <p className="section-lead">Люди, благодаря которым проекты организации живут и развиваются.</p>
                </div>

                <div className="card-glass volunteer-card reveal">
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-4 text-center">
                            <div className="volunteer-photo">
                                <img src={photo} alt="Якименко Роман Эдуардович — волонтёр организации"/>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <h3 className="person-name">Якименко Роман Эдуардович</h3>
                            <p className="person-role">Волонтёр с 2019 года · разработчик</p>
                            <p className="person-text">
                                Активный участник проектов организации, а также разработчик сайта организации
                                и Telegram-бота слёта любителей английского языка «English Summer Camp» —
                                на волонтёрских началах.
                            </p>
                            <div className="volunteer-tags">
                                <span>Проекты организации</span>
                                <span>Веб-разработка</span>
                                <span>Telegram-бот</span>
                                <span>English Summer Camp</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Volunteers;
